export async function fetchRetry(url, options, retries = 3) {
    const backoff = (delay) => new Promise((resolve) => setTimeout(resolve, delay));
    try {
        return await fetch(url, options);
    } catch (error) {
        if (retries > 0) {
            const delay = 2 ** (3 - retries) * 1000 + (Math.random() - 0.5) * 1000;
            console.log(`Retrying ${url} in ${delay} ms, ${retries} retries left`);
            await backoff(delay);
            return fetchRetry(url, options, retries - 1);
        }
    }
}
